import { Transition } from '@headlessui/react';
import { memo, useRef } from 'react';
import { ContentTypeDropdownProps } from '../types';
import Icon from '@/components/atoms/Icon';
import { classnames } from '@/libs/utils';

function AiSearchContentTypeDropdown({
  selectedOption,
  isVisible,
  isSelected,
  options,
  onToggle,
  onSelect,
  disabled = false
}: ContentTypeDropdownProps) {
  const dropdownRef = useRef<HTMLDivElement>(null);

  return (
    <div className="relative" ref={dropdownRef}>
      <Transition
        appear
        show={isSelected}
        className="overflow-hidden"
        enter="transform duration-700 ease-out"
        enterFrom="max-w-0"
        enterTo="max-w-[500px]"
        leave="transform duration-500 ease-in"
        leaveFrom="max-w-[500px]"
        leaveTo="max-w-0"
      >
        <button
          type="button"
          className="flex shrink-0 items-center gap-2 whitespace-nowrap rounded-lg bg-black/[0.08] px-3 py-2 text-sm font-medium text-black hover:bg-neutral-200 disabled:cursor-not-allowed disabled:opacity-50"
          onClick={onToggle}
          disabled={disabled}
        >
          <div>{selectedOption?.label}</div>
          <Icon name={isVisible ? 'IconChevronUp' : 'IconChevronDown'} size={16} />
        </button>
      </Transition>

      {/* Dropdown Menu */}
      <Transition
        appear
        show={isVisible}
        className="absolute top-10 z-[80] mt-1 w-full text-black"
        enter="duration-100 ease-out"
        enterFrom="scale-95 opacity-0 origin-bottom-right"
        enterTo="scale-100 opacity-100 origin-bottom-right"
        leave="transition duration-75 ease-out"
        leaveFrom="scale-100 opacity-100 origin-bottom-right"
        leaveTo="scale-95 opacity-0 origin-bottom-right"
      >
        <div className="pt-1.5">
          <div className="relative max-h-72 w-[186px] rounded-lg border bg-white px-1.5 py-2 shadow">
            {options.map(option => {
              return (
                <button
                  data-test-id="saved-search-option-button"
                  type="button"
                  onClick={() => onSelect(option)}
                  key={option.label}
                  data-testid={`dropdown-option-${option.type}`}
                  className={classnames(
                    'z-10 flex w-full items-center gap-2 rounded-lg px-2 py-2.5 text-left text-sm hover:bg-slate-100',
                    selectedOption?.label === option.label ? 'bg-black/[0.04]' : 'bg-white'
                  )}
                >
                  {option.label}
                </button>
              );
            })}
          </div>
        </div>
      </Transition>
    </div>
  );
}

export default memo(AiSearchContentTypeDropdown);
